import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import AgentReportDateWise from "../../components/lead-management/agent-report/agentReportDateWise";

const DateSaleReport = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Daily Sales">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <AgentReportDateWise userInfoData={userInfoData} pageName="datewise-sale" />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DateSaleReport;
